define.alias("shared/components/shared/ui/social-profile-switcher/item", "calendar/components/shared/ui/social-profile-switcher/item");